var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMastering = function SvgMastering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.657 4.473a1.45 1.45 0 1 0 0 2.898 1.45 1.45 0 0 0 0-2.898m-.25 1.449a.25.25 0 1 1 .499 0 .25.25 0 0 1-.498 0M11.657 9.835a5.128 5.128 0 1 0 0 10.256 5.128 5.128 0 0 0 0-10.256m-3.929 5.128a3.928 3.928 0 1 1 7.857 0 3.928 3.928 0 0 1-7.857 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.864 0A2.864 2.864 0 0 0 2 2.864v18.113a2.864 2.864 0 0 0 2.864 2.864H18.45a2.864 2.864 0 0 0 2.864-2.864V2.864A2.864 2.864 0 0 0 18.45 0zM3.2 2.864c0-.919.745-1.664 1.664-1.664H18.45c.92 0 1.664.745 1.664 1.664v18.113c0 .92-.745 1.665-1.664 1.665H4.864c-.919 0-1.664-.746-1.664-1.665z",
    clipRule: "evenodd"
  })));
};
export default SvgMastering;